"use client";

import React from 'react';
import ReportCard from './ReportCard'; // Assuming ReportCard is in the same directory or properly aliased

interface Report {
  slug: string;
  title: string;
  primary_industry_name: string;
  price_amount: number;
  content_id: number;
  legacy_report_id?: number;
  published_year: number;
  published_at?: string;
  discounted_price?: number;
  discounted_id?: number | string;
  discounted_percent?: number;
  cover_image_url?: string;
  summary?: string;
  metadata_json?: {
    cover_image_url?: string;
    image_url?: string;
  };
}

interface ReportListProps {
  reports: Report[];
  loading: boolean;
  error: string | null;
  onAddToCart: (contentId: number, price: number, imageUrl?: string) => void | Promise<void>;
  isCsrMode?: boolean;
  /** Called for each action on a card (index = 0-based row): open, sample, enquiry, cart. */
  onAction?: (action: 'open' | 'sample' | 'enquiry' | 'cart', contentId: number, index: number) => void;
}

const ReportList: React.FC<ReportListProps> = ({ reports, loading, error, onAddToCart, isCsrMode, onAction }) => {
  if (loading) {
    return <p>Loading reports...</p>;
  }

  if (error) {
    return <p className="error-text">{error}</p>;
  }

  const safeReports = reports || [];

  if (safeReports.length === 0) {
    return <p>No reports found.</p>;
  }

  return (
    <>
      {safeReports.map((report, index) => (
        <div className="row report-grid" key={report.content_id}>
          <div className="col-md-12">
            <div className="col-md-12">
              <ReportCard
                report={report}
                onAddToCart={onAddToCart}
                isCsrMode={isCsrMode}
                onAction={onAction ? (action) => onAction(action, report.content_id, index) : undefined}
              />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ReportList;
